<template>
  <el-select
    :value="value"
    size="small"
    filterable
    clearable
    :collapse-tags="collapseTags"
    :loading="loading"
    @change="handleChange"
    remote
    :remote-method="requestData"
    placeholder="搜索并选择"
    style="width: 100%"
    multiple
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.code"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { itemList } from '@/service/getData'

export default {
  props: {
    value: {
      type: Array,
      value: [],
    },
    templateId: {
      type: Number,
      default: 0,
    },
    baseId: {
      type: Number,
      default: 0,
    },
    modelNumber: String,
    collapseTags: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [],
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData(query) {
      this.loading = true
      let model_number = query || this.modelNumber
      let data = {
        transfer_list: true,
        base_id: this.baseId,
        item_template_id: this.templateId,
        model_number: model_number,
        size: 20,
      }

      let res = await itemList(data)
      this.loading = false
      this.lists = res.data.list.map((item) => {
        let code = this.modelNumber
          ? item.code + '（' + item.model_number + '）'
          : item.code
        return { id: item.id, code: code }
      })
    },
  },
}
</script>